export interface CaseStudy {
  id: string;
  client: string;
  industry: string;
  industryTag: string;
  headline: string;
  challenge: string;
  solution: string;
  services: string[];
  results: { stat: string; label: string }[];
  image: string;
  screenshotUrl?: string;
  featured?: boolean;
}

export const caseStudies: CaseStudy[] = [
  {
    id: 'mission-beach-dive',
    client: 'Mission Beach Dive',
    industry: 'Tourism',
    industryTag: 'ri-anchor-line',
    headline: 'From buried on Google to fully booked in 52 days.',
    challenge: "Losing dive course bookings to aggregator sites and larger operators — despite being the only PADI Centre in Mission Beach. Zero Google presence for their best search terms.",
    solution: 'Full website rebuild showcasing their unique tropical reef advantage, hyper-local SEO targeting dive-specific searches, and AI chat to capture after-hours course and trip enquiries.',
    services: ['Website Design', 'Local SEO', 'AI Chat Automation'],
    results: [
      { stat: '#1', label: 'Google Ranking (52 days)' },
      { stat: '4.2x', label: 'Booking Enquiries' },
      { stat: '60%', label: 'After-Hours Leads Captured' },
    ],
    image: 'https://public.readdy.ai/ai/img_res/fdeaec3086b1b06707ffb2c83bdd2f68.jpg',
    screenshotUrl: 'https://storage.readdy-site.link/project_files/cb16f62b-b978-4a18-b0d4-78b46c2aa554/2ad694cf-cbee-4737-a59e-8817e5f48e7c_Screenshot-2026-03-22-at-10.34.03.png?v=97146f67a6d9674b8f021395be33d1b4',
    featured: true,
  },
  {
    id: 'dunk-island-ferry',
    client: 'Dunk Island Ferry',
    industry: 'Tourism',
    industryTag: 'ri-ship-line',
    headline: 'Brand new service. Zero traction. Now the official page.',
    challenge: 'A brand-new ferry service with no web presence, no domain authority, and being consistently outranked by established tour aggregators and similar operators for every relevant local search term — before a single booking had been made.',
    solution: 'Built a launch-ready website with clear service positioning, then executed hyper-local SEO to claim official status fast — structured content, citation building, and entity signals that told Google this was the authoritative source before competitors could entrench the terms.',
    services: ['Website Design', 'Local SEO', 'Content Strategy'],
    results: [
      { stat: '#1', label: 'Official Ferry Page' },
      { stat: '0→Top 3', label: 'Core Terms Ranking' },
      { stat: '100%', label: 'Organic Traffic Share' },
    ],
    image: 'https://readdy.ai/api/search-image?query=professional ferry service website displayed on a MacBook laptop mockup against a dark studio background, the website has a clean modern layout with ocean blue and white color scheme, beautiful tropical island photography with turquoise water and Dunk Island Queensland visible as the hero image, clear bold headline text and professional navigation bar, Australian ferry booking website, high quality commercial web design portfolio photography with dramatic dark background and subtle ocean blue ambient lighting&width=900&height=600&seq=darkside-portfolio-dunkislandferry-v2&orientation=landscape',
    screenshotUrl: 'https://storage.readdy-site.link/project_files/cb16f62b-b978-4a18-b0d4-78b46c2aa554/673a0dad-9a9a-4328-9133-7e98875606b2_Screenshot-2026-03-30-at-11.36.14.png?v=69fcbde0eaa9637c631ab4bfe36d8607',
    featured: false,
  },
  {
    id: 'mission-beach-adventures',
    client: 'Mission Beach Adventures',
    industry: 'Tourism',
    industryTag: 'ri-compass-3-line',
    headline: 'Now cited by ChatGPT and Google Gemini for reef trips in Mission Beach.',
    challenge: 'Competing against large aggregators and established reef tour operators while trying to win both traditional Google rankings and the emerging AI search landscape — where one confident recommendation from ChatGPT or Gemini can drive an entire week\'s bookings.',
    solution: 'New website architected for AI retrieval from day one — answer-ready content, FAQ schema, and entity signals built to satisfy both Google and generative AI. GEO programme layered on top to earn citations across ChatGPT, Gemini AI Overviews, and Perplexity for every high-intent reef trip and adventure query.',
    services: ['Website Design', 'GEO / AEO'],
    results: [
      { stat: 'AI', label: 'ChatGPT & Gemini Cited' },
      { stat: 'Top 3', label: 'Core Reef Trip Terms' },
      { stat: '100%', label: 'Organic — Zero Ad Spend' },
    ],
    image: 'https://readdy.ai/api/search-image?query=professional adventure tourism website displayed on a MacBook laptop in a dark photography studio, the website has a rich dark teal and forest green color scheme with dramatic tropical Queensland coastal photography, above the fold shows headline text reef trips island adventures private charters with stunning Mission Beach tropical reef and island aerial photography, turquoise Coral Sea and Dunk Island visible in hero image, lush rainforest meeting beach, clean professional web design with bold white typography, commercial portfolio photography with moody dark studio background and soft teal green ambient rim lighting&width=900&height=600&seq=darkside-portfolio-mba-adventures-v4&orientation=landscape',
    screenshotUrl: 'https://storage.readdy-site.link/project_files/cb16f62b-b978-4a18-b0d4-78b46c2aa554/67aa56b2-595f-451c-adde-296da0c0988c_Screenshot-2026-03-30-at-11.43.57.png?v=fef523a7aada8d0240176aed206b9f65',
    featured: false,
  },
];

export const industries = ['All', 'Tourism'];